export const APP_LANGUAGES = [
  { code: "en", name: "English", nativeName: "English" },
  { code: "es", name: "Spanish", nativeName: "Español" },
  { code: "zh", name: "Chinese", nativeName: "中文" },
  { code: "fil", name: "Tagalog", nativeName: "Tagalog" },
  { code: "vi", name: "Vietnamese", nativeName: "Tiếng Việt" },
  { code: "ar", name: "Arabic", nativeName: "العربية" },
  { code: "fr", name: "French", nativeName: "Français" },
  { code: "ko", name: "Korean", nativeName: "한국어" },
  { code: "ru", name: "Russian", nativeName: "Русский" },
  { code: "de", name: "German", nativeName: "Deutsch" },
];

export const APP_LANGUAGE_STORAGE_KEY = "bd_voice_language";
export const APP_LANGUAGE_CHANGED_EVENT = "brighter-dayz-language-changed";

export function getAppLanguage() {
  if (typeof window === "undefined") return "en";
  const saved = window.localStorage.getItem(APP_LANGUAGE_STORAGE_KEY);
  return APP_LANGUAGES.some((language) => language.code === saved) ? saved : "en";
}

export function setAppLanguage(code) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(APP_LANGUAGE_STORAGE_KEY, code);
  window.dispatchEvent(new CustomEvent(APP_LANGUAGE_CHANGED_EVENT, { detail: code }));
}

export function getLanguage(code) {
  return APP_LANGUAGES.find((language) => language.code === code) || APP_LANGUAGES[0];
}
